export default "__VITE_ASSET__BkCkLKUT__"